import { useContext, useEffect, useState } from "react";
import {
  Info,
  WalletActions,
  WalletAddress,
  WalletBalance,
  WalletInfoStyle,
} from "./styled";
import { shortenAddress } from "../../../utils/addressUser";
import CopyToClipboard from "react-copy-to-clipboard";
import { toast } from "react-hot-toast";
import { CopyOutlined } from "@ant-design/icons";
import { ButtonCommon } from "../../../Layout/styled";
import TextBalance from "../../Common/TextBalance";
import Loading from "../../Loading";
import { ContextProviderWrapper } from "../../Context";
import { useBalance as useBalanceEVM } from "wagmi";
import { useAppKitAccount, useAppKitBalance } from "@reown/appkit/react";
import { useDisconnect } from "@reown/appkit/react";
import { getDataTokenLogin } from "../../../store/features/poolsSlice";
import { useDispatch } from "../../../store/store";
import { useTonAddress, useTonConnectUI } from "@tonconnect/ui-react";
import { useBalance } from "../../../hooks/Ton/useBalance";
import { convertFixed } from "../../../utils/convertNumber";
import { useNavigate } from "react-router-dom";

export default function WalletInfo({ onCloseModal, listChains, chain }: any) {
  const { theme } = useContext(ContextProviderWrapper)!;
  const { address }: any = useAppKitAccount();
  const { fetchBalance }: any = useAppKitBalance();
  const { disconnect } = useDisconnect();
  const [balance, setBalance] = useState(0);
  const addressTon = useTonAddress();
  const result = useBalanceEVM({
    address,
  });
  const { tonBalance } = useBalance();
  const dispatch = useDispatch();
  const [tonConnectUI] = useTonConnectUI();
  const navigate = useNavigate();

  const handleChangeName = (chain: any) => {
    switch (chain) {
      case "Avalanche":
        return "AVAX";
      case "Solana":
        return "SOL";
      case "Toncoin":
        return "TON";
    }
  };

  const handleFetchSol = async () => {
    const balance = await fetchBalance();
    setBalance(Number(balance.data?.balance));
  };

  useEffect(() => {
    if (chain === "Solana" && address) {
      handleFetchSol();
    }
  }, [chain, address]);

  const handleDisconnect = async () => {
    try {
      await tonConnectUI.disconnect();
      onCloseModal();
    } catch (error) {
      console.error("error", error);
    }
  };

  return (
    <WalletInfoStyle
      onClick={(e: any) => {
        e.stopPropagation();
      }}
    >
      <Info>
        <WalletAddress className={theme}>
          <div>
            <h1>
              Address:
              <span>
                {chain === "Toncoin"
                  ? shortenAddress(addressTon)
                  : shortenAddress(address)}
              </span>
            </h1>
          </div>
          <CopyToClipboard
            text={chain === "Toncoin" ? `${addressTon}` : `${address}`}
            onCopy={() => {
              toast.success("Copied !!");
            }}
          >
            <div
              style={{
                marginRight: "14px",
                color: "#92929E",
                cursor: "pointer",
              }}
            >
              <span>Copy</span>
              <CopyOutlined />
            </div>
          </CopyToClipboard>
        </WalletAddress>
        <WalletBalance>
          <h2>
            {handleChangeName(
              listChains?.find((item: any) => item.name === chain)?.name
            )}{" "}
            balance
          </h2>
          {(address || addressTon) && (
            <TextBalance
              balance={`${
                chain === "Solana"
                  ? Number(balance).toFixed(3)
                  : chain === "Toncoin"
                  ? convertFixed(Number(tonBalance))
                  : isNaN(balance) || isNaN(Number(result?.data?.formatted))
                  ? 0
                  : Number(result?.data?.formatted).toFixed(3)
              }`}
              isImage
              listChains={listChains}
              chain={chain}
            />
          )}
        </WalletBalance>
        <WalletActions>
          <ButtonCommon
            background="#E94A4A"
            onClick={() => {
              navigate("/profile");
              onCloseModal();
            }}
          >
            Profile
          </ButtonCommon>
          <ButtonCommon
            background="#E94A4A"
            onClick={() => {
              dispatch(getDataTokenLogin(null));
              localStorage.clear();
              if (chain === "Toncoin") {
                handleDisconnect();
              } else {
                disconnect();
              }
              onCloseModal();
            }}
          >
            <Loading status={false} title="Disconnect" />
          </ButtonCommon>
        </WalletActions>
      </Info>
    </WalletInfoStyle>
  );
}
